var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 206.43 69.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5962a;}.cls-2{fill:#868a95;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 25") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14,69.2H0l3.53-7.28H14a3.64,3.64,0,1,1,0,7.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.44,15.66l-.1-.09A3.48,3.48,0,0,1,62,10.39a34.59,34.59,0,0,1,49.37-.06,3.48,3.48,0,0,1-.34,5.18l-.1.09a3.51,3.51,0,0,1-4.68-.34,27.46,27.46,0,0,0-39.12.05,3.53,3.53,0,0,1-4.68.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.7,34.51v.14a3.48,3.48,0,0,0,3.49,3.48h22.44a1.12,1.12,0,0,1,1.11,1.32,27.52,27.52,0,0,1-27,22.6c-10.31,0-18.85-3.56-26.44-19.06L40.58,2.61C39-.74,34.19-.74,32.82,2L12.11,44.34c-.47,1,0,1,.49,1H40.54A3.48,3.48,0,0,0,44,41.86v-.22a3.48,3.48,0,0,0-3.48-3.49H23.91a.42.42,0,0,1-.36-.62L35.82,12.42a.83.83,0,0,1,1.49,0l16.4,33.66c8.64,17.7,20.55,23.5,34.18,23A34.66,34.66,0,0,0,121.28,34.4V32.15A1.13,1.13,0,0,0,120.15,31h-30a3.49,3.49,0,0,0-3.49,3.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M147,21.94H140.2v2.3h4.43A3.67,3.67,0,0,1,141.06,27a4,4,0,1,1,0-8.08,3.57,3.57,0,0,1,3.16,1.8l2.33-.65a6,6,0,0,0-5.49-3.46,6.35,6.35,0,1,0,0,12.7A6.12,6.12,0,0,0,147.12,23a5.58,5.58,0,0,0-.09-1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 148.57,
    y: 16.31,
    width: 2.31,
    height: 12.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M157.09,29.3a4.77,4.77,0,1,0-4.77-4.77,4.76,4.76,0,0,0,4.77,4.77m0-7.22a2.46,2.46,0,1,1-2.46,2.45,2.45,2.45,0,0,1,2.46-2.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.6,28.05a3.53,3.53,0,0,0,2.75,1.25,4.62,4.62,0,0,0,4.47-4.77,4.62,4.62,0,0,0-4.47-4.76A3.53,3.53,0,0,0,165.6,21V16.31h-2.3V29h2.3Zm2.46-6a2.46,2.46,0,1,1-2.46,2.45,2.45,2.45,0,0,1,2.46-2.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.74,29.3a3.51,3.51,0,0,0,2.74-1.25v1h2.31v-9h-2.31v1a3.51,3.51,0,0,0-2.74-1.25,4.62,4.62,0,0,0-4.47,4.76,4.62,4.62,0,0,0,4.47,4.77m.29-7.22a2.46,2.46,0,1,1-2.46,2.45A2.45,2.45,0,0,1,179,22.08"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 185.24,
    y: 16.31,
    width: 2.31,
    height: 12.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.91,37.51c-1.75-.29-2.45-.6-2.45-1.43s1.08-1.31,2.3-1.31A5.16,5.16,0,0,1,143,35.92l1-2a6.47,6.47,0,0,0-4.15-1.48c-3,0-4.65,1.77-4.65,3.79,0,1.84,1.17,3.12,4.61,3.64,1.59.24,2.46.67,2.46,1.52s-.92,1.44-2.53,1.44a5.33,5.33,0,0,1-3.82-1.73l-1.16,2a6.74,6.74,0,0,0,4.95,2c3.21,0,4.87-1.73,4.87-3.9,0-2.6-2-3.32-4.62-3.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M150.59,35.63c-3.12,0-4.62,2.13-4.62,4.77s1.54,4.76,5,4.76a6.3,6.3,0,0,0,3.37-.85l-.67-2a4.79,4.79,0,0,1-2.67.83,2.61,2.61,0,0,1-2.65-2h6.51c0-.24,0-.53,0-.72,0-3-1.53-4.77-4.33-4.77m-2.16,3.76a2,2,0,0,1,2-1.74,1.86,1.86,0,0,1,2,1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.67,37.82v-1.9h-2.3v8.95h2.3V41.12a2.76,2.76,0,0,1,2-2.76,3.38,3.38,0,0,1,1.73,0V35.63a4.18,4.18,0,0,0-3.76,2.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "168.49 41.41 166.47 35.92 163.87 35.92 167.62 44.87 169.36 44.87 173.11 35.92 170.51 35.92 168.49 41.41"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 174.62,
    y: 35.92,
    width: 2.31,
    height: 8.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.77,31.59a1.59,1.59,0,1,0,1.59,1.59,1.59,1.59,0,0,0-1.59-1.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M183.47,37.94a3,3,0,0,1,2.08.83l.95-2.07a4.77,4.77,0,1,0,0,7.39L185.55,42a3,3,0,0,1-2.08.81,2.47,2.47,0,1,1,0-4.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M192.57,35.63c-3.12,0-4.62,2.13-4.62,4.77s1.53,4.76,5,4.76a6.31,6.31,0,0,0,3.38-.85l-.67-2a4.79,4.79,0,0,1-2.67.83,2.6,2.6,0,0,1-2.65-2h6.51c0-.24,0-.53,0-.72,0-3-1.54-4.77-4.33-4.77m-2.17,3.76a2,2,0,0,1,2-1.74,1.86,1.86,0,0,1,2,1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.83,39.17c-1-.16-1.89-.25-1.89-.79,0-.38.67-.56,1.61-.55a5.88,5.88,0,0,1,2.83.76L206,36.5a7.82,7.82,0,0,0-3.48-.87c-2.35,0-3.92,1.3-3.92,2.75s.56,2.52,3.9,3.06c1.19.2,1.59.35,1.59.74,0,.56-.78.8-1.84.78a5.24,5.24,0,0,1-3.18-1.26l-.76,2.16a6.85,6.85,0,0,0,4.15,1.3c2.49,0,3.94-1.35,3.94-3.18,0-1.13-.56-2.32-3.6-2.81"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.8801cfb4602b93cbe071b84d1fc5f0f6.svg";
export { ForwardRef as ReactComponent };